import React from "react";
import { IconType } from "react-icons";
import { useNavigate, useLocation } from "react-router-dom";
import "./sidebaritems.scss";

interface Props {
  Icon: IconType
	text: string
  path: string; 
}

const SidebarItem = ({ Icon, text, path }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = location.pathname === path;

  return (
    <div 
      className={`component_sidebaritems ${isActive ? "active" : ""}`} 
      onClick={() => navigate(path)}
    >
      <div className="sidebar_icon">
        <Icon size={"20px"}/>
      </div>
      <span className="sidebar_text">{text}</span>
    </div>
  );
};

export default SidebarItem;